export default __webpack_public_path__ + "static/media/Nix.0799139b.png";